import { render, staticRenderFns } from "./dimension.vue?vue&type=template&id=34ab80bb&"
import script from "./dimension.vue?vue&type=script&lang=js&"
export * from "./dimension.vue?vue&type=script&lang=js&"
import style0 from "./dimension.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzTextField: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/text-field/index.js').default})
